// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"bb7ca4ab25be74c687ab","691":"f24fa2f3c8a058494224"}[chunkId] + ".js";
};